// File: src/English/EnglishTool/advancedAdjectiveQuestions.js
import { shuffleArray } from "./shuffleArray.js";

// Predicate/Attributive Adjectives
export function buildPredicativeAdjectiveMC() {
  return {
    questionType: "MC",
    question: "Which sentence contains a predicate adjective?",
    correctAnswer: "The solution is complex.",
    options: shuffleArray([
      "The solution is complex.",
      "The complex solution worked.",
      "Complex solutions work.",
      "He solved the problem."
    ])
  };
}

// Participial Adjective
export function buildParticipialAdjectiveMC() {
  return {
    questionType: "MC",
    question: "Which phrase is a participial adjective?",
    correctAnswer: "tiring",
    options: shuffleArray([
      "tiring",
      "the marathon",
      "was finished",
      "very quickly"
    ])
  };
}

// Comparative/Superlative
export function buildComparativeSuperlativeAdjMC() {
  return {
    questionType: "MC",
    question: "What are the comparative and superlative forms of 'intelligent'?",
    correctAnswer: "more intelligent, most intelligent",
    options: shuffleArray([
      "more intelligent, most intelligent",
      "intelligenter, intelligentest",
      "intelligently, most intelligently",
      "intelligent, most intelligent"
    ])
  };
}

// Non-restrictive clause
export function buildNonRestrictiveClauseMC() {
  return {
    questionType: "MC",
    question: "Which sentence uses a non-restrictive adjective clause?",
    correctAnswer: "My book, which is on the table, is new.",
    options: shuffleArray([
      "My book, which is on the table, is new.",
      "The book that is on the table is new.",
      "On the table is my new book.",
      "I bought a new book."
    ])
  };
}

// Identify all adjectives
export function buildAdjectiveIdentify() {
  return {
    questionType: "IDENTIFY",
    question: "Type all adjectives in this sentence, separated by commas: 'The tall, graceful athlete won the final race.'",
    correctAnswers: ["tall", "graceful", "final"]
  };
}

// Adjective placement
export function buildAdjectivePlacementMC() {
  return {
    questionType: "MC",
    question: "Where can adjectives be placed in this sentence: 'She wore a ___ dress'?",
    correctAnswer: "Before the noun",
    options: shuffleArray([
      "Before the noun",
      "After the noun",
      "At the end of the sentence",
      "Anywhere in the sentence"
    ])
  };
}

// FITB: Write a sentence using 'remarkable'
export function buildFITBRemarkable() {
  return {
    questionType: "FITB",
    question: "Write a sentence using the adjective 'remarkable'.",
    correctAnswer: "remarkable",
    checkType: "keyword-in-sentence",
    requiredWord: "remarkable"
  };
}

export const allAdvancedAdjectiveQuestions = [
  buildPredicativeAdjectiveMC,
  buildParticipialAdjectiveMC,
  buildComparativeSuperlativeAdjMC,
  buildNonRestrictiveClauseMC,
  buildAdjectiveIdentify,
  buildAdjectivePlacementMC,
  buildFITBRemarkable,
];
